import React, { Component } from 'react';
import { Container, Row} from 'reactstrap';
function redondearHaciaArriba(valor: number): number {
    const decimal = valor % 1;
    return decimal >= 0.5 ? Math.ceil(valor) : Math.floor(valor);
}

export class DetalleProveedor extends Component {

    constructor(props) {
        super(props);
        this.state = { proveedor: props.proveedor };
    }

    render() {
        const factorSumaItems = [];
        if (this.state.proveedor.FactoresQueSuman !== undefined) {
            for (var i = 0; i < this.state.proveedor.FactoresQueSuman.length; i++) {
                factorSumaItems.push(
                    <div className={"cc" + this.state.proveedor.FactoresQueSuman[i].color}>
                        {this.state.proveedor.FactoresQueSuman[i].nombre}:
                        &nbsp;
                        {
                            this.state.proveedor.FactoresQueSuman[i].color === 3 ?
                            <> - </> :
                            redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[i].valor)
                        } 
                    </div>
                )
            }
        }

        const factorRestaItems = [];
        if (this.state.proveedor.factoresQueRestan !== undefined) {
            for (var j = 0; j < this.state.proveedor.factoresQueRestan.length; j++) {
                factorRestaItems.push(
                    <div className={"cc" + this.state.proveedor.factoresQueRestan[j].ok}>
                        {this.state.proveedor.factoresQueRestan[j].nombre}:
                        &nbsp;
                        {
                            redondearHaciaArriba(this.state.proveedor.factoresQueRestan?.[j]?.valor ?? 0) ?
                            <> X </> :
                            <> - </>
                        }
                    </div>
                )
            }
        }
        

        return (
            <><br/><Container>
                <Row>
                    <div className="col-12">
                        <h5>{this.state.proveedor.RazonSocial}</h5>
                        {factorSumaItems}
                        {factorRestaItems}
                        <h5>Total: {redondearHaciaArriba(this.state.proveedor.Total)}</h5>
                    </div>
                </Row>
            </Container></>
        );
    }
}